import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../../../layouts/general-layout';
import { useAllMissionsStore } from '../../../../utils/allMissionsStore';
import { RouterConstant } from '../../../../routers/index';
import { MissionItem } from '../../../../services/missions/missions.service';

export const useAllMissions = () => {
  const { t } = useLayoutContext();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  const {
    openMissions,
    completedMissions,
    isLoading,
    fetchAllMissions
  } = useAllMissionsStore();

  useEffect(() => {
    fetchAllMissions();
  }, [fetchAllMissions]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleMissionPress = (p: MissionItem) => {
    if (p.type === 'lesson') {
      navigate(RouterConstant.ROUTERS_PATH.PLAY_LESSON, {
        state: {
          lessonId: p.lesson_id,
          topicName: p.full_topic_label,
          levelName: p.level_name,
          topicId: p.topic_id,
          levelId: p.level_id,
          sub_topic_id: p.sub_topic_id,
          lastInteractionId: p.last_interaction_id,
          resume: true
        }
      });
    } else {
      navigate(RouterConstant.ROUTERS_PATH.DISPLAYEXERCISE, {
        state: {
          exerciseId: p.exercise_id,
          topicName: p.full_topic_label,
          resume: true
        }
      });
    }
  };

  return {
    t,
    navigate,
    tabValue,
    handleTabChange,
    openMissions,
    completedMissions,
    isLoading,
    handleMissionPress
  };
};
